import React from "react";
import image1 from "../images/zeus.png";
import { Link } from 'react-router-dom';
import { useDocumentTitle } from "../hooks/useDocumentTitle";

function Zeus() {
  useDocumentTitle("Zeus");
  return (
    <>
      <div
        style={{
          width: "100%",
          height: "25rem",
          backgroundColor: "#333",
          backgroundImage: `url(${image1})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right top",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
        }}
      >
        <h1
          style={{
            color: "White",
            marginLeft: "10rem",
          }}
        >
          Zeus Auction Service
        </h1>
      </div>

      <div
        style={{
          width: "100%",
          minHeight: "25rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingLeft: "1rem",
          paddingRight: "7rem",
        }}
      >
        <div
          style={{
            width: "50%",
            color: "#a04020",
            paddingRight: "2rem"
          }}
        >
          <center>
            <h2
              style={{
                marginRight: "1rem"
              }}
            >
              Meet Zeus.
            </h2>
            <p style={{ fontSize: "1.25rem", fontWeight: 500, marginBottom: 0 }}>Your government auction solution.</p>
          </center>
        </div>
        <div
          style={{
            width: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <p>
            The Zeus Auction Program incorporates the latest technology and
            over 20 years of experience to make bidding in auctions easy.
            Manage your account, view live statistics, and place single or
            multiple bids from one place.
          </p>

          <Link to="/support" className="btn btn-primary" id="lapBtn">
            Inquire about Zeus
          </Link>
        </div>
      </div>
    </>
  );
}

export default Zeus;
